var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2072_33747)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.59375,
    y: 1.37244,
    width: 15,
    height: 11.4375,
    rx: 2,
    fill: "#2469EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00879 9.55997L5.24756 7.86856L6.68506 8.96487L9.43506 4.96487L12.8726 8.96487",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34375 14.6276H12.8437",
    stroke: "#2469EF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2072_33747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.09375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM3);
export default __webpack_public_path__ + "static/media/m3.aef07099f8e3da0a2e83a1ce2ab498d5.svg";
export { ForwardRef as ReactComponent };